import forbidden from './forbidden';
import notFound from './notFound';

export default {
  forbidden,
  notFound,
};
